import React from "react";
import "./passreset.css";

export default function Passreset() {
  return (
    <form className="loginregister">
      <h1>Reset Password</h1>

      <input type="email" placeholder="EMAIL" />
      <input type="phone" placeholder="PHONE NUMBER" />

      <button type="submit" className="butto">
        SEND ME RESET CODE
      </button>
    </form>
  );
}
